<app-base-page-template>
  <app-base-page-content-template>
    <app-customers-grid
      (rowClick)="onRowClicked($event)"
      (addButtonClick)="onAddButtonClicked()">
    </app-customers-grid>
  </app-base-page-content-template>
</app-base-page-template>
